import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MeSubpageShell } from '../../components/chrome/MeSubpageShell';
import { isFirstHistoryEntry } from '../../lib/history-back';
import styles from './AboutCoursesPage.module.css';

const BASICS_PARAGRAPHS = ['p1', 'p2', 'p3', 'p4'] as const;
/** The «Время» paragraph is an intro line, three short lines (a list) and a closing line. */
const PRACTICE_BEFORE_LIST = ['p1', 'p2'] as const;
const PRACTICE_LIST = ['p2a', 'p2b', 'p2c'] as const;
const PRACTICE_AFTER_LIST = ['p2d', 'p3'] as const;
const HOW_ITEMS = ['lessons', 'task', 'ai', 'quiz', 'exam', 'chat', 'pace'] as const;

/** Free course and optional AI discussion; no legacy review quota. */
export function AboutCoursesPage(): JSX.Element {
  const { t } = useTranslation('course');
  const navigate = useNavigate();
  // Opened only from «Мой курс», so back is a step back (no second /course entry in history); on the first entry go there.
  const backToCourse = (): void => { if (isFirstHistoryEntry()) navigate('/course', { replace: true }); else navigate(-1); };

  return (
    <MeSubpageShell title={t('about.pageTitle')} onBack={backToCourse} data-testid="about-page">
      <div className={styles.body}>
        <section className={styles.section} data-testid="about-course-basics">
          <h2 className={styles.heading}>{t('about.basics.title')}</h2>
          {BASICS_PARAGRAPHS.map((k) => <p key={k} className={styles.text}>{t(`about.basics.${k}`)}</p>)}
        </section>
        <section className={styles.section} data-testid="about-course-practice">
          <h2 className={styles.heading}>{t('about.practice.title')}</h2>
          {PRACTICE_BEFORE_LIST.map((k) => <p key={k} className={styles.text}>{t(`about.practice.${k}`)}</p>)}
          <ul className={styles.list}>
            {PRACTICE_LIST.map((k) => <li key={k}>{t(`about.practice.${k}`)}</li>)}
          </ul>
          {PRACTICE_AFTER_LIST.map((k) => <p key={k} className={styles.text}>{t(`about.practice.${k}`)}</p>)}
        </section>
        <section className={styles.section} data-testid="about-how">
          <h2 className={styles.heading}>{t('about.how.title')}</h2>
          <ul className={styles.list}>
            {HOW_ITEMS.map((k) => <li key={k}>{t(`about.how.${k}`)}</li>)}
          </ul>
        </section>
      </div>
    </MeSubpageShell>
  );
}
